<template>
  <b-card>
    <!-- Form -->
    <b-form class="p-2">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Tanggal" label-for="tanggal">
            <b-form-input
              v-model="formattedDate"
              name="tanggal"
              placeholder="dd-mm-yyyy"
              @change="updateDate"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="Waktu Wawancara" label-for="waktu_wawancara">
            <b-form-input
              v-model="userData.waktu_wawancara"
              name="waktu_wawancara"
              placeholder="HH:mm"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="Tempat Wawancara" label-for="tempat_wawancara">
            <b-form-input
              v-model="userData.tempat_wawancara"
              name="tempat_wawancara"
              placeholder="tempat wawancara"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-2"
          @click="updateData"
        >
          Simpan
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BRow, BCol,
  BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    var userData = this.rowData.data
    return {
      userData,
      formattedDate: moment(userData.tanggal).format('DD-MM-YYYY')
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  watch: {
    formattedDate(newVal) {
      this.userData.tanggal = moment(newVal, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
  },
  methods: {
    updateDate(event) {
      this.formattedDate = event.target.value;
    },
    async updateData() {
      this.userData.tanggal = moment(this.formattedDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
      store.dispatch('jadwal-wawancara/updateData', this.userData)
        .then(response => {
          this.makeToast('success', 'Simpan Data Jadwal Wawancara Berhasil Dilakukan')
          setTimeout(() => {
            this.$router.push({ name: 'jadwal-wawancara' })
          }, 3000);
        })
        .catch(error => {
          console.error(error)
        })
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Jadwal Wawancara',
        variant,
        solid: true,
        autoHideDelay: 3000,
      })
    },
  },
}
</script>

<style>
</style>
